import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Typography } from '@material-ui/core';
import { Tooltip } from '@mui/material';
import UserWithRoleScheduleToolTip from '~/modules/common/components/User/UserWithRoleScheduleToolTip';
import { ResourceRoleSchedule } from '~/modules/common/components/entities/role';

const useStyles = makeStyles(theme => ({
  roleRow: {
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    ...theme.typography.caption,
    width: 128
  }
}));

const tooltipContentId = 'resource-profile-roles-tooltip-content';

export const RoleScheduleWithTooltip = ({
  roleScheduleAsOfDate,
  showEffectiveDate = false,
  resourceRoleScheduleClasses,
  classes: classesOverrides
}) => {
  const classes = useStyles({ classes: classesOverrides });

  const effectiveSchedule = roleScheduleAsOfDate || {};

  const tooltipContent = useMemo(
    () => (
      <div id={tooltipContentId}>
        <UserWithRoleScheduleToolTip effectiveSchedule={effectiveSchedule} />
      </div>
    ),
    [effectiveSchedule]
  );

  return (
    <Tooltip
      title={tooltipContent}
      placement="top"
      aria-describedby={tooltipContentId}
    >
      <Typography component="div" tabIndex={0} className={classes.roleRow}>
        <ResourceRoleSchedule
          effectiveSchedule={effectiveSchedule}
          showEffectiveDate={showEffectiveDate}
          classes={resourceRoleScheduleClasses}
        />
      </Typography>
    </Tooltip>
  );
};

RoleScheduleWithTooltip.propTypes = {
  roleScheduleAsOfDate: PropTypes.object,
  showEffectiveDate: PropTypes.bool,
  resourceRoleScheduleClasses: PropTypes.object,
  classes: PropTypes.object
};

export default RoleScheduleWithTooltip;
